export default __webpack_public_path__ + "static/media/logo.94757144.png";